import sileo from 'sileo';

const DetailsOvertimeRequest = new sileo.Model('hqzen', 'overtime-request-details');
const OvertimeRequestComments = new sileo.Model('hqzen', 'overtime-request-comments');
const CommentAttachmentAmazonCredentials = new sileo.Model(
    'hqzen', 'comments-amazon-form-data');
const CommentAttachments = new sileo.Model(
    'hqzen', 'comment-attachments');
const PayrollIssues = new sileo.Model('hqzen', 'employee-payroll-issues');
const EmploymentPayrollResource = new sileo.Model('hqzen', 'employment-payroll');
const Screenshots = new sileo.Model('hqzen', 'screenshots');
const ScheduleIssueFileAmazonCredentials = new sileo.Model(
    'hqzen', 'issue-file-amazon-form-data');
const ScheduleIssues = new sileo.Model(
    'hqzen', 'schedule-issues');
const ScheduleIssueAttachments = new sileo.Model(
    'hqzen', 'schedule-issue-attachments');
const EmployeeCalculationItemRequest = new sileo.Model('hqzen', 'employee-calculation-item-request');
const AllowanceAttachmentAmazonCredentials = new sileo.Model('hqzen', 'allowance-attachment-amazon-form-data');
const EmployeeCalculationItemAttachment = new sileo.Model('hqzen', 'employee-calculation-item-attachment');
const EmployeePayrollSummary = new sileo.Model('hqzen', 'employee-payroll-summary');
const AllowanceRequests = new sileo.Model('hqzen', 'allowance-requests');
const AllowanceRequestComments = new sileo.Model('hqzen', 'allowance-request-comments');
const EmploymentLeaveRequests = new sileo.Model('hqzen', 'employment-leave-request-list');
const EmploymentLeaveDetails = new sileo.Model('hqzen', 'employment-leave-request');
const EmployeeLeaveCategory = new sileo.Model('hqzen', 'employee-leave-category');
const LeaveType = new sileo.Model('hqzen', 'employment-leave-type');
const LeaveAmazonFormData = new sileo.Model('hqzen', 'leave-amazon-form-data');
const IncidentReportList = new sileo.Model('hqzen', 'employee-incident-reports-list');
const IncidentReportDetails = new sileo.Model('hqzen', 'incident-report-details');
const EmploymentUpdatesList = new sileo.Model('hqzen', 'updates-list');
const EmploymentUpdateDetails = new sileo.Model('hqzen', 'updates-details');
const EmploymentPendingUpdatesCount = new sileo.Model('hqzen', 'updates-count');
const EmploymentDAFsList = new sileo.Model('hqzen', 'employment-dafs-list');
const EmploymentDAFDetails = new sileo.Model('hqzen', 'employee-daf-details');
const EmploymentDAFsPendingCount = new sileo.Model('hqzen', 'employee-daf-count');
const RecentEmploymentRuleChange = new sileo.Model('bposeats', 'recent-employment-rule-change');
const SimpleEmploymentBlockStatus = new sileo.Model('bposeats', 'simple-employment-block-status');
const EmploymentPCNsCount = new sileo.Model('hqzen', 'employment-pcns-count');
const Employment201FilesList = new sileo.Model('hqzen', 'employee-files');
const EmploymentRequirements = new sileo.Model('hqzen', 'employee-requirements');
const ResumeApplicantRequirement = new sileo.Model('hqzen', 'resume-applicant-requirement');
const Employment201FilesAmazonResource = new sileo.Model('hqzen', 'requirement-amazon-form-data');
const Employment201FilesPendingCount = new sileo.Model('hqzen', 'pending-requirements-count');
const EmploymentPayrollDateStatus = new sileo.Model('hqzen', 'employee-payroll-date-status');
const EmploymentResignation = new sileo.Model('hqzen', 'resignation');
const EmploymentResignationAttachment = new sileo.Model('hqzen', 'resignation-amazon-form-data');
const EmploymentIncidentReportCount = new sileo.Model('hqzen', 'employment-incident-report-count');
const EmploymentClearanceDetails = new sileo.Model('hqzen', 'clearance-details');
const EmploymentExitInterviewAndClearancePrompt = new sileo.Model('hqzen', 'exit-interview-and-clearance-prompt');
const DAFAppeal = new sileo.Model('hqzen', 'appeal');
const AppealAmazonFormData = new sileo.Model('applybpo', 'appeal-amazon-form-data');
const FaceRecognitionCaptures = new sileo.Model('hqzen', 'employment-face-recognition-captures');
const DaysScheduleChecker = new sileo.Model('hqzen', 'employment-days-check');


const state = {
    employment: null,
    currentBlockinstance: null,
};

const getters = {};

const mutations = {
    setEmployment(state, employment) {
        state.employment = employment;
    },

    clearEmployment(state) {
        state.employment = null;
    },

    setCurrentBlockInstance(state, blockedPartner) {
        state.currentBlockInstance = blockedPartner;
    },

};

const actions = {
    fetchResignationResource(context, filters) {
        return EmploymentResignation.objects.filter(filters);
    },

    createResignationApplication(context, data) {
        const formData = new FormData();

        formData.append('status', data.status);
        formData.append('separation_type', data.separation_type);
        formData.append('employment_id', data.employment_id);
        formData.append('reason', data.reason);
        formData.append('effective_date', data.effective_date);
        formData.append('location', data.location);
        formData.append('signature_uuid', data.signature_uuid);
        formData.append('compliance_status', data.compliance_status);
        formData.append('attachments', JSON.stringify(data.attachments));
        formData.append('immediate', data.immediate);

        return EmploymentResignation.objects.create(formData);
    },

    withdrawResignation(context, data) {
        const { pk, ...payload } = data;
        const formData = new FormData();

        Object.keys(payload).forEach(key => {
            formData.append(key, data[key]);
        });

        return EmploymentResignation.objects.update({
            'pk': pk
        }, formData);
    },

    async fetchResignationAttachmentAmazonFormData(context, file_type) {
        return EmploymentResignationAttachment.objects.filter(
            { file_type: file_type }).then(data => {
                return data.amazon;
            });
    },

    async fetchResignationSignatureAmazonFormData(context, file_type) {
        return EmploymentResignationAttachment.objects.filter(
            { file_type: file_type,
              signature_attachment: true }).then(data => {
            return data.amazon;
        });
    },

    fetchEmployment201FilesPendingCount(context, filters) {
        return Employment201FilesPendingCount.objects.filter(filters);
    },

    fetchEmployment201FilesList(context, filters) {
        return Employment201FilesList.objects.filter(filters);
    },

    fetchRequirements(context, filters) {
        return EmploymentRequirements.objects.filter(filters);
    },

    fetchResumeRequirement(context, pk) {
        return ResumeApplicantRequirement.objects.filter({ applicant_id: pk });
    },

    async fetch201FilesAmazonFormData(context, file_type) {
        let data = await Employment201FilesAmazonResource.objects.filter({ file_type: file_type });
        return data.amazon;
    },

    updateApplicantRequirement(context, data) {
        const { pk, ...payload } = data;
        const formData = new FormData();

        Object.keys(payload).forEach(key => {
            formData.append(key, data[key]);
        });

        return Employment201FilesList.objects.update({
            'pk': pk
        }, formData);
    },

    createApplicantRequirement(context, data) {
        const formData = new FormData();

        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        });

        return Employment201FilesList.objects.create(formData);
    },

    cancelApplicantRequirement(context, pk) {
        return Employment201FilesList.objects.delete({ pk: pk });
    },

    fetchDAFsList(context, filters) {
        return EmploymentDAFsList.objects.filter(filters);
    },

    fetchDAFDetails(context, pk) {
        return EmploymentDAFDetails.objects.get(pk);
    },

    fetchOvertimeRequest(context, pk) {
        return DetailsOvertimeRequest.objects.get(pk);
    },

    deleteOvertimeRequest(context, pk) {
        return DetailsOvertimeRequest.objects.update(pk);
    },

    fetchOvertimeRequestComments(_, pk) {
        return OvertimeRequestComments.objects.filter({ overtime_request_id: pk });
    },

    createOvertimeRequestComment(_, data) {
        let form = new FormData();
        for (let item in data) {
            form.append(item, data[item]);
        }
        return OvertimeRequestComments.objects.create(form);
    },


    /**
     *
     * @param {*} _ This is the context
     * @param {*} pk This is the primary key (pk) of the comment to be deleted
     * @returns
     */
    deleteOvertimeRequestComment(_, pk) {
        return OvertimeRequestComments.objects.delete({ pk });
    },

    /**
     * Updates the overtime request comment.
     *
     * @param {any} _ - The placeholder parameter.
     * @param {Object} data - The data object containing the comment information.
     * @returns {Promise} A promise that resolves with the updated overtime request comment.
     */
    updateOvertimeRequestComment(_, data) {

        return OvertimeRequestComments.objects.update({ pk: data.pk }, data);
    },

    async fetchCommentAttachmentAmazonFormData(context, filters) {
        return await CommentAttachmentAmazonCredentials.objects.filter(filters).then(amazon => {
            return amazon.amazon;
        });
    },

    createCommentAttachment(context, form) {
        return CommentAttachments.objects.create(form);
    },

    fetchPayrollIssues(context, filters) {
        return PayrollIssues.objects.filter(filters);
    },

    fetchEmploymentPayroll(context, pk) {
        return EmploymentPayrollResource.objects.get(pk);
    },

    fetchScreenshots(context, filters) {
        return Screenshots.objects.filter(filters);
    },

    async fetchScheduleIssueFileAmazonFormData(context, filters) {
        return await ScheduleIssueFileAmazonCredentials.objects.filter(filters).then(amazon => {
            return amazon.amazon;
        });
    },

    createScheduleIssue(_, data) {
        let form = new FormData();
        for (let item in data) {
            form.append(item, data[item]);
        }
        return ScheduleIssues.objects.create(form);
    },

    createScheduleIssueAttachment(_, data) {
        let form = new FormData();
        for (let item in data) {
            form.append(item, data[item]);
        }
        return ScheduleIssueAttachments.objects.create(form);
    },

    createAllowanceRequest(context, data) {
        const form = new FormData();
        let key;

        for (key in data) {
            form.append(key, data[key]);
        }

        return EmployeeCalculationItemRequest.objects.create(form);
    },

    fetchEmployeeAllowanceRequestDetails({ commit }, pk) {
        return EmployeeCalculationItemRequest.objects.get(pk);
    },

    updateEmployeeAllowanceRequest(context, { pk, data }) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }

        return EmployeeCalculationItemRequest.objects.update(pk, form);
    },

    cancelEmployeeAllowanceRequest(context, filters) {
        return EmployeeCalculationItemRequest.objects.delete(filters);
    },

    fetchEmployeeAllowanceRequestAttachment(context, filters) {
        return EmployeeCalculationItemAttachment.objects.filter(filters);
    },

    createEmployeeAllowanceRequestAttachment(context, filters) {
        return EmployeeCalculationItemAttachment.objects.create(filters);
    },

    deleteEmployeeAllowanceRequestAttachment(context, filters) {
        return EmployeeCalculationItemAttachment.objects.delete(filters);
    },

    fetchAllowanceAttachmentAmazonFormData(context, file_type) {
        return AllowanceAttachmentAmazonCredentials.objects.filter(
        { file_type: file_type }).then(data => {
            return data.amazon;
        });
    },

    getEmployeePayrollSummary(context, id) {
        return EmployeePayrollSummary.objects.get(id);
    },

    fetchAllowanceRequests(context, filters) {
        return AllowanceRequests.objects.filter(filters);
    },

    fetchAllowanceRequestComments(_, pk) {
        return AllowanceRequestComments.objects.filter({ request_id: pk });
    },

    createAllowanceRequestComment(_, data) {
        let form = new FormData();
        for (let item in data) {
            form.append(item, data[item]);
        }
        return AllowanceRequestComments.objects.create(form);
    },

    fetchEmploymentLeaveRequests(context, filters) {
        return EmploymentLeaveRequests.objects.filter(filters);
    },

    getEmploymentLeaveDetails(context, leave_pk) {
        return EmploymentLeaveDetails.objects.get(leave_pk);
    },

    fetchEmployeeLeaveCategory(context, employee_pk) {
        return EmployeeLeaveCategory.objects.get(employee_pk);
    },

    cancelEmploymentLeaveRequest(context, data) {
        const formData = new FormData();
        let key;

        for (key in data) {
            formData.append(key, data[key]);
        }

        return EmploymentLeaveDetails.objects.update({ pk: data.pk }, formData).then(response => {
            return response;
        }).catch(response => {
            return { error: response.response };
        });
    },

    getLeaveTypes(context, pk) {
        return LeaveType.objects.get(pk);
    },

    async createLeaveRequest(context, payload) {
        const data = payload.data;

        const form = new FormData();

        form.append('signature_uuid', data.signature_uuid);
        form.append('employment', data.employment);
        form.append('leave_type', data.leaveType);
        form.append('note', data.note);
        form.append('location', data.location);
        form.append('attachments', JSON.stringify(data.attachments));
        form.append('leave_dates', JSON.stringify(data.rawLeaveDates));
        form.append('status', data.status);
        if (data.hourly_value != null) {
            form.append('hourly_value', data.hourly_value);
        }

        return await EmploymentLeaveDetails.objects.create(form).catch(response => {
            resolve({ error: response.response });
        });
    },

    async fetchLeaveAttachmentAmazon(context) {
        let filters = {
            'leave_attachment': 'True',
        };
        let data = await LeaveAmazonFormData.objects.filter(filters);
        return data.amazon;
    },

    async uploadSignatureFileToAmazon(context) {
        return await LeaveAmazonFormData.objects.filter(
            { signature_attachment: true }).then(data => {
            return data.amazon;
        });
    },

    fetchEmployeeIncidentReports(context, filters) {
        return IncidentReportList.objects.filter(filters);
    },

    fetchEmployeeIncidentReportDetails(context, pk) {
        return IncidentReportDetails.objects.get(pk);
    },

    async archiveIncidentReport(context, payload) {
        let pk = payload.pk;
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }
        await IncidentReportDetails.objects.update({ pk }, formData);
    },

    async acknowledgeIncidentReport(context, pk) {
        await IncidentReportDetails.objects.update({ pk });
    },

    async answerIncidentReport(context, payload) {
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }
        await IncidentReportDetails.objects.update({ pk: payload.incident_report_id }, formData);
    },

    async createDAFAppeal(context, payload) {
        let signature = payload.signature;
        let formData = new FormData();
        formData.append('daf_pk', payload.daf_pk);
        formData.append('reason_for_appeal', payload.reason_for_appeal);
        formData.append('location', payload.location);
        formData.append('attachments', JSON.stringify(payload.attachments));
        formData.append('employment_pk', payload.employment_pk);

        return new Promise((resolve, reject) => {
            signature.save(async(blob) => {
                formData.append('signature_file', blob, 'signature.png');
                delete payload.signature;
                resolve(await DAFAppeal.objects.create(formData));
            });
        });
    },

    async fetchAppealAmazonFormData(context, file_type) {
        return AppealAmazonFormData.objects.filter(
            { file_type: file_type }).then(data => {
                return data.amazon;
            });
    },

    async acknowledgeDaf(context, payload) {
        let pk = payload.pk;
        let signature = payload.signature;
        let formData = new FormData();
        return new Promise((resolve, reject) => {
            signature.save(async(blob) => {
                formData.append('signature_file', blob, 'signature.png');
                delete payload.signature;
                for (let key in payload) {
                    formData.append(key, payload[key]);
                }
                resolve(await EmploymentDAFDetails.objects.update({ pk }, formData));
            });
        });
    },

    async answerDaf(context, payload) {
        let pk = payload.pk;
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }
        await EmploymentDAFDetails.objects.update({ pk }, formData);
    },

    async updateDafStatus(context, payload) {
        let pk = payload.pk;
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }

        await EmploymentDAFDetails.objects.update({ pk }, formData);
    },

    acknowledgeEmploymentDocument(context, payload) {
        let pk = payload.pk;
        let location = payload.location;
        let signature = payload.signature_file;
        return new Promise((resolve, reject) => {
            signature.save(async (blob) => {
                const formData = new FormData();
                formData.append('signature', blob);
                formData.append('location', location);
                resolve(await EmploymentUpdateDetails.objects.update({ 'pk': pk }, formData));
            });
        });
    },

    fetchEmploymentUpdatesList(context, data) {
        return EmploymentUpdatesList.objects.filter(data);
    },

    fetchEmploymentUpdateDetails(context, pk) {
        return EmploymentUpdateDetails.objects.get(pk);
    },

    fetchEmploymentPendingUpdatesCount(context, filters) {
        return EmploymentPendingUpdatesCount.objects.filter(filters);
    },

    fetchEmploymentBlockStatus(context, filters) {
        return SimpleEmploymentBlockStatus.objects.get(filters.pk);
    },

    fetchRecentEmploymentRuleChange(context, employment_id) {
        return RecentEmploymentRuleChange.objects.get(employment_id);
    },

    fetchEmploymentPCNsCount(context, filters) {
        return EmploymentPCNsCount.objects.filter(filters);
    },

    fetchEmploymentPendingDAFsCount(context, filters) {
        return EmploymentDAFsPendingCount.objects.filter(filters);
    },

    fetchEmploymentPayrollDateStatus(context, filters) {
        return EmploymentPayrollDateStatus.objects.filter(filters);
    },

    fetchEmploymentIRCount(context, filters) {
        return EmploymentIncidentReportCount.objects.filter(filters);
    },

    fetchEmploymentClearanceDetails(context, filters) {
        return EmploymentClearanceDetails.objects.filter(filters);
    },

    getExitInterviewAndClearanceIDs(context, pk) {
        return EmploymentExitInterviewAndClearancePrompt.objects.get(pk);
    },

    fetchFaceRecognitionCaptures(context, filters) {
        return FaceRecognitionCaptures.objects.filter(filters);
    },

    fetchEmploymentDayWorkingStatuses(context, filters) {
        return DaysScheduleChecker.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
